import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import GoodsCounpon from './GoodsCoupon/script';
import { COUPON_STATUS } from '../constants/index';
import Describe from '../utils/lib/describe';
import componentUtils from '../utils/index';

const { getGiftEventName } = componentUtils;
const { isFunction, createUniqueId } = common;

const defaultSubtitle = '多门店通用，活动商品可用';
const defaultGetBtn = '一键领取大额券';

const COMPONENT_ID = 'waimai_lf2qcxgl';
const SUB_COMPONENT_RED_BAG_ID = 'waimai_31pa3pum';

const describeRedBagList = new Describe('RedBagList', COMPONENT_ID);
const describeRedBag = new Describe('RedBag', SUB_COMPONENT_RED_BAG_ID);

describeRedBagList.setSubComponent('RedBag', describeRedBag);

const checkHasNewStatus = (skuCouponList) => {
    return skuCouponList.some(
        (poiInfo) => poiInfo.giftInfo.status === COUPON_STATUS.STATUS_NEW,
    )
};
class GoodsCounponList {
    static describe = describeRedBagList;
    constructor(props = {}) {
        this.sgSkuCouponModuleID = createUniqueId();
        this.receiveAllBtnId = createUniqueId();
        this.propsCache = props;
        this.component = this.createDom(props);
    }
    createDom = (props) => {
        const {
            skuCouponList = [],
            onClickReceiveAll,
            onCounponAndGooodsClick, 
            couponSubtitle = defaultSubtitle,
            reciveAllBtnText = defaultGetBtn,
        } = props;

        const hiddenCb = () => {
            if(!checkHasNewStatus(skuCouponList)) {
                dom.$id(this.receiveAllBtnId).style.display = 'none';
            }
        }
      
        const skuCouponListDom = skuCouponList.length ? (skuCouponList.map((poiInfo, index) => {

            const skuCouponDom = GoodsCounpon({
                poiInfo,
                onCounponAndGooodsClick, 
                couponSubtitle,
                hiddenCb
            });
            return (`<div class="mb20" coupon-monitor-index=${index}> ${skuCouponDom}</div>`)
        }).join('')) : '';


        const data = {
            receiveAllBtnId: this.receiveAllBtnId,
            sgSkuCouponModuleID: this.sgSkuCouponModuleID,
            skuCouponListDom,
            isShowRecievBtn: checkHasNewStatus(skuCouponList),
            reciveAllBtnText
        };

        const events = {
            onClickReceiveAllBtn: async () => {
                if (isFunction(onClickReceiveAll)) {
                    await onClickReceiveAll(skuCouponList);
                }
            },
        };
        return createComponent(tpl, { data, style }, events);
    };
    getComponent = () => {
        return this.component;
    };
    render = (props) => {
        const container = dom.$id(this.sgSkuCouponModuleID);
        this.component = this.createDom({ ...this.propsCache, ...props });
        container.outerHTML = this.component;
    };
}

export default GoodsCounponList;
